.help {
  margin: 0 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-2);
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) 0;
}

.who {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.email {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.add {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  margin-bottom: var(--space-2);
}

.error {
  margin: 0 0 var(--space-2);
  color: var(--danger-text);
}

.link {
  background: none;
  border: 0;
  padding: 0;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
}
